import * as applicationConfig from "../../config";
import Icon from "Core/components/display/Icon";
import {rtrimChar} from "Core/helpers/string";
import {icon_font_stack_class} from 'Config/app';
import {AclCheckDataObject} from "Core/acl";
import {getArray} from "Core/helpers/data";

/**
 * Variable representing whether the page is a project page or not
 * @type {boolean}
 */
export const isProjectPage = true;

/**
 * Rendered icon element used as a page icon
 * @description Page icons can be used in the main navigation, page links and buttons or any other place.
 * @type {JSX.Element}
 */
export const iconElement = (
	<Icon
		symbol={['users', 'circle-thin']}
		stackClassName={`${icon_font_stack_class} user-groups`}
	/>
);

/**
 * Access control settings
 * @type {AclCheckDataObject}
 */
export const access = new AclCheckDataObject(
	[...getArray(applicationConfig, 'access.permissions'), 'CUSTOMER_READ', 'CUSTOMER_WRITE'],
	[...getArray(applicationConfig, 'access.userTypes'), ],
	undefined
);

/**
 * Page router path relative to the base path of the app
 * @note Use '/' at the beginning (for example '/home').
 * @type {string}
 */
export const routerPath = `${rtrimChar(applicationConfig.routerPath, '/')}/project/:projectId/customer-groups`;
/**
 * Page router options used for router matching
 * @type {{[exact]: boolean, [strict]: boolean, [sensitive]: boolean}}
 */
export const routerOptions = {exact: false};
/**
 * Page router options used for router matching in the main sidebar menu
 * @type {{[exact]: boolean, [strict]: boolean, [sensitive]: boolean}}
 */
export const menuRouterOptions = {exact: false};

/**
 * Page translation path
 * @type {string}
 */
export const translationPath = `${applicationConfig.translationPath}.projectPages.CustomerGroupsPage`;